export const promptFileDownload = (fileBlob, filename) => {
  const url = window.URL.createObjectURL(fileBlob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const parseFilenameFromContentDisposition = (header) => {
  if (!header) return null;
  const encodedMatch = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header);
  if (encodedMatch?.[1]) {
    try {
      return decodeURIComponent(encodedMatch[1]);
    } catch {
      return encodedMatch[1];
    }
  }
  const plainMatch = /filename\s*=\s*"?(?<name>[^";]+)"?/i.exec(header);
  return plainMatch?.groups?.name ?? null;
};

// Trigger a browser download from a (pre-signed) URL. S3 sets
// Content-Disposition: attachment, so the browser downloads rather than navigates.
export const downloadFromUrl = (url) => {
  if (typeof url !== "string" || url.trim() === "") {
    console.error("downloadFromUrl called with invalid URL:", url);
    return;
  }
  const a = document.createElement("a");
  a.href = url;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
};
